export default __webpack_public_path__ + "static/media/prontuario.0c2a8b8a.png";